<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Update {{hsbc.hsbc_code }} </p>
    <v-form ref="updHsbc">
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="hsbc.hsbc_opm" label="Remark"></v-text-field>
      </v-col>
     </v-row>  
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="updHsbc">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hsbc_encrid: null,
      hsbc: {}
    }
  },
  methods: {
    open(hsbc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/inpt/bookingcom/getHsbc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsbc"
          },
          getHsbc: {
            hsbc_encrid: hsbc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsbc = res.data.getHsbc;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updHsbc() { 
      this.$axios
        .post("ares/json/ares/task/inpt/bookingcom/updHsbc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHsbc"
          },
          updHsbc: {
            hsbc_encrid: this.hsbc.hsbc_encrid,
            hsbc_opm: this.hsbc.hsbc_opm
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 

             if (res.data.updHsbc.color == "success") { 
                setTimeout(() => { this.$router.reload('/task/inpt/bookingcom/search1')  }, 2000);      
             }         
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHsbc.text,
              color: res.data.updHsbc.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

